/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const AlertRhombusIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="alert-rhombus-icon">
      <path d="M11.5,15 L11.5,7" />
      <polygon points="11.5 1.5001524 22.4996476 12.4998 11.5 23.4994476 0.5003524 12.4998" />
      <path d="M12,18.5 C12,18.776 11.776,19 11.5,19 C11.224,19 11,18.776 11,18.5 C11,18.224 11.224,18 11.5,18 C11.776,18 12,18.224 12,18.5 Z" />
    </g>
  </svg>
);

export default AlertRhombusIcon;
